import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import NOB from '../../../../constants/language-strings';
import { useLinkProduct } from 'modules/CustomerProducts/api';
import { Heading } from 'modules/CustomerProducts/components/product/heading';
import styled from 'styled-components';
import { Icon } from '@purpurds/purpur/icon';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import { icons } from 'theme/icons';
import { RadioButton } from 'components/Buttons/RadioButton/radio-button';
import { CheckboxField, PebbleSpinner } from 'components';
import { StatusMessage } from 'components/status-message/status-message';
import spacing from 'theme/spacing';
const Linking = styled.div `
  width: 100%;
  margin-bottom: ${spacing.spacing40};
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
  margin: 0 ${spacing.spacing4} ${spacing.spacing4} 0;
`;
const StyledList = styled.ul `
  width: 100%;
  max-width: 750px;
  list-style: none;
  margin: 0;
  padding: 0;
`;
const ListItem = styled.li `
  padding-top: ${spacing.spacing16};
  margin-left: ${spacing.spacing16};
`;
const StyledCheckboxField = styled(CheckboxField) `
  font-weight: 500;
`;
export const LinkingContainer = ({ customerId, productId, product, isProductFetching, }) => {
    const { name, linkOptions, multipleLinksAllowed } = product;
    const subHeading = `${NOB.LINKING.WHERE_SHALL} ${name} ${NOB.LINKING.BE_LINKED}`;
    const [errorMessage, setErrorMessage] = useState(null);
    const [pending, setPending] = useState({});
    const { linkSingleDpad, linkProductDpads, isLinking, error: linkError, } = useLinkProduct(customerId, productId);
    const onCheckboxClick = (dpadId) => {
        const option = linkOptions.find(o => o.dpadId === dpadId);
        if (!option)
            return;
        setPending(prev => (Object.assign(Object.assign({}, prev), { [dpadId]: !option.isLinked })));
        linkProductDpads(dpadId);
    };
    const onRadioClick = (dpadId) => linkSingleDpad(dpadId);
    if (isProductFetching)
        return _jsx(PebbleSpinner, {});
    if (!linkOptions || linkOptions.length === 0)
        return null;
    const handleCloseError = () => {
        setErrorMessage(null);
    };
    useEffect(() => {
        if (linkError) {
            setErrorMessage(linkError);
        }
    }, [linkError]);
    return (_jsxs(Linking, { children: [_jsx(Heading, { icon: _jsx(StyledIcon, { svg: icons.link, size: 'md' }), mainHeading: NOB.LINKING.NO_AVAILABLE, subHeading: subHeading }), _jsx(StyledList, { children: linkOptions.map(option => {
                    const labelBase = `${option.name} (${option.serialNumber ? option.serialNumber : 'Ikke aktiv'})`;
                    const spinnerActive = isLinking;
                    return (_jsx(ListItem, { children: multipleLinksAllowed ? (_jsx(StyledCheckboxField, { id: 'linking-checkbox', label: labelBase, checked: pending[option.dpadId] !== undefined
                                ? pending[option.dpadId]
                                : option.isLinked, onClick: () => onCheckboxClick(option.dpadId), name: option.dpadId.toString() })) : (_jsx(RadioButton, { label: labelBase, checked: option.isLinked, onClick: () => onRadioClick(option.dpadId), name: option.dpadId.toString(), value: option.dpadId, isFetching: spinnerActive })) }, option.agreementDetailId));
                }) }), (errorMessage) && (_jsx(StatusMessage, { type: 'error', message: errorMessage, onDismiss: handleCloseError }))] }));
};
